<template>
    <div class="query_list">
        <div class="query_input_box">
            <el-input placeholder="请输入单位名称或域名或关键词或备案号" v-model="queryObj.key" @keyup.enter="handleChangedi" class="input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="handleChangedi">搜索</el-button>
            </el-input>
        </div>
        <div class="query_box">
            <div class="query_box_item">
                <div class="title">搜索平台：</div>
                <el-radio-group v-model="queryObj.type" @change="handleChangedi">
                    <el-radio-button v-for="(item,index) in checkboxList1" :key="index" :label="item.val">
                        {{item.text}}
                    </el-radio-button>
                </el-radio-group>
            </div>
            <div class="query_box_item wu">
                <div class="title">更多筛选：</div>
                <!-- <el-cascader
                    placeholder="企业地区"
                    clearable
                    v-model="queryObj.down"
                    :options="provinceData"
                    :props="{ value: 'label'}"
                    @change="handleChangedi">
                </el-cascader> -->
                <el-select v-model="queryObj.pro" placeholder="请选择省份" @change="handleChangedi">
                    <el-option
                        v-for="(item,index) in provinceData"
                        :key="index"
                        :label="item.label"
                        :value="item.label">
                    </el-option>
                </el-select>
                <el-select v-model="queryObj.promote" placeholder="选择推广" @change="handleChangedi">
                    <el-option
                        v-for="(item,index) in xzArr"
                        :key="index"
                        :label="'推广:'+item.text"
                        :value="item.value">
                    </el-option>
                </el-select>
                
                <el-select v-model="queryObj.state" placeholder="网站能否访问" @change="handleChangedi">
                    <el-option
                        v-for="(item,index) in xzArr"
                        :key="index"
                        :label="'网站能否访问:'+item.text"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="query_box_item wu">
                <div class="title">联系方式：</div>
                <el-select v-model="queryObj.phone" placeholder="手机号码" @change="handleChangedi">
                    <el-option
                        v-for="(item,index) in xzArr"
                        :key="index"
                        :label="'手机号码:'+item.text"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="queryObj.tel" placeholder="固定电话" @change="handleChangedi">
                    <el-option
                        v-for="(item,index) in xzArr"
                        :key="index"
                        :label="'固定电话:'+item.text"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="queryObj.email" placeholder="邮箱" @change="handleChangedi">
                    <el-option
                        v-for="(item,index) in xzArr"
                        :key="index"
                        :label="'邮箱:'+item.text"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
    </div>
</template>
<script>
import {provinceData,industry} from '../common/newData'
export default {
    name:"queryList",
    data(){
        return{
            provinceData:provinceData,
            industry:industry,
            queryObj:{
                promote:0,
                type:0,
                pro:'全部',
                key:'',
                state:0,
                phone:0,
                tel:0,
                email:0
            },
            checkboxList1: [
				{
					text: '全部',
					val:0
				},
				{
					text: '企业',
					val:1
				},
				{
					text: '个人',
					val:2
				},
				{
					text: '事业单位',
					val:3
				},
				{
					text: '社会团体',
					val:4
				}
			],
            xzArr:[
				{
					text:'有',
					value:2
				},
				{
					text:'无',
					value:1
				},
				{
					text:'全部',
					value:0
				},
			],
        }
    },
    methods:{
        handleChangedi() {
            this.$emit('queryType',this.queryObj);
        }
    },
    mounted(){
        this.queryObj.key = this.$route.query.text;
    }
}
</script>
<style lang="scss" scoped>
.el-button{
    background: #1F81F8 !important;
    color: #FFFFFF !important;
    padding-bottom: 8 !important;
    padding-top: 8 !important;
    margin-top: -30px !important;
}
.query_box_item.wu .el-input__inner{
    /* border: none; */
    font-size: 16px;
}
.query_box_item.wu .el-select{
    width: 16%;
    margin-right: 40px;
    color: #666666;
}
.query_box_item .el-cascader{
    width: 16%;
    margin-right: 40px;
}
.query_list{
    height: auto;
    @media screen and (max-width: 1400px){
        width: 960px;
        margin: 0 auto 0;
        background-color: #fff;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
        margin: 0 auto 0;
        background-color: #fff;
    }
    >div.query_input_box{
        width: 100%;
        height: auto;
        padding: 20px 35px;
        box-sizing: border-box;
        border-bottom: 1px solid #F6F7FB;
        .input-with-select{
            width: 50%;
        }
    }
    >div.query_box{
        width: 100%;
        height: auto;
        padding: 20px 36px;
        box-sizing: border-box;
        >div.query_box_item{
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            cursor: default;
            >div.title{
                line-height: 40px;
                font-weight: 500;
                color: #000000;
                font-size: 16px;
                margin-right: 10px;
            }
        }
        >div.query_box_item.jg{
            margin-top: 20px;
            margin-bottom: 20px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/modular/querylist2.vue